import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '@assets/languages/en.json'
import it from '@assets/languages/it.json';
import Cookies from 'js-cookie';
import { COOKIE_ENUM } from '@webkit/enums/cookie.enum';
import es from '@assets/languages/es.json';
import de from '@assets/languages/de.json';
import fr from '@assets/languages/fr.json';

const resources = {
  en: { translation: en },
  it: { translation: it },
  de: { translation: de },
  fr: { translation: fr },
  es: { translation: es },
};

const currLang = Cookies.get(COOKIE_ENUM.HST_LANG) || navigator.language?.substring(0, 2) || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: currLang, // lingua di default
    fallbackLng: 'en', // lingua di fallback
    interpolation: {
      escapeValue: false,
    },
});